import { useResponsive } from './use-responsive';

import { Capacitor } from '@capacitor/core';

/**
 * The app's platform rule, shared so every feature agrees on what "desktop
 * web" and "mobile web" mean (NFC capture, autofocus, scanner promos…).
 *
 * - mobile web: narrow web viewport — invite to the native app instead of
 *   using hardware that web mobile can't reach.
 * - desktop web: wide web viewport — keyboard-wedge readers, autofocus, etc.
 * - native (Capacitor iOS/Android) is neither.
 */
export function usePlatformFlags() {
  const smDown = useResponsive('down', 'sm');
  const isNative = Capacitor.isNativePlatform();

  return {
    isNative,
    isMobileWeb: smDown && !isNative,
    isDesktopWeb: !smDown && !isNative,
  };
}
